import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";
import { listEditionError } from "@planzone/dto";

function createInteractor(repository: Repository): Interactor {
  return ({ list, nextList }) =>
    present(
      repository.editList(list, nextList).catch((error) =>
        Promise.reject({
          error: { ...listEditionError, ...error },
          list,
          nextList,
        }),
      ),
    );
}

export type { Interactor };

export { createInteractor };
